import Vue from 'vue';
import Vuex from 'vuex';
import bio from './modules/bio-highlight';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        bio,
    },
});

export default store;
